module.exports = __webpack_public_path__ + "static/media/preview.1da7ad31.png";